module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ELqKbq/media/FC-9789948786306.jpg?1701092748534",
      "alt": "This image is the cover for the book الناصر صلاح الدين الأيوبي: نظرة الغرب لبطل الشرق"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("الناصر صلاح الدين الأيوبي: نظرة الغرب لبطل الشرق\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("هذا الكتاب يبرز نبذة مختصرة عن حياة القائد صلاح الدين الأيوبي.  أردتُ أن أُظهِر رؤية الغرب لصفات ومميِّزات وعيوب هذه الشخصية الأسطورية المسلمة مِن خلال ترجمة مصادر إنجليزية وفرنسية عديدة، وكذلك استشارة مصادر عربية فيما يتعلَّق ببعض التفاصيل التاريخية والدينية، وبذلك تتعدَّد زوايا قراءة تاريخه. أبهرني إظهارهم للحقيقة بدون مبالغة، وتقييمهم ونقدهم البَنَّاء، فإذا كان هذا رأي الغرب (الصليبيِّين) فيه، فما بالك بحقيقة شخصيَّته مِن وجهة نظر معاصِريه؟ توجد مساحات لَم يسلَّط عليها الضوء في سيرته الذاتية، نعلم الكثير عن إنجازاته، ونعلم القليل عن شخصيَّته، مثله مثل غيره مِن حُكَّام العصور الوسطى. الفصول الثلاثة الأخيرة مِن الكتاب تتناول ما نستطيع أن نتعلَّمه مِن هذه الشخصيَّة، وكيف يمكننا الاستفادة مِن أخلاقه وأفعاله.. أرجو مِن الله أن تتمتَّعوا وتستفيدوا مِن هذا العمل.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      د.مجدي عز الدين حنفي\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("د. مجدي عز الدين حنفي. - استشاري الجراحة بإنجلترا. - بكالوريوس طب وجراحة.. كلية الطب - جامعة الأزهر (تقدير امتياز مع مرتبة الشرف). - زميل الكليات الملكية للجراحين بالمملكة المتحدة. - مؤلف كتاب \"كيف خلقَنا الله سبحانه وتعالى\"، مكتبة الأنجلو المصرية 2006.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0